import styled from 'styled-components'

const Title = styled.p`
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  && {
    font-weight: 600;
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  padding-bottom: 30px;
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    row-gap: 15px;
    padding-bottom: 15px;
  }
`

const EssentialExtrasContainer = styled.div`
  border: 1px solid ${props => props.theme.color.monochrome.light};
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  flex-direction: column;
  height: auto;
`

const ItemsWrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: row;
  column-gap: 0px;
  justify-content: space-around;

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].md}) {
    flex-direction: row;
    padding: 16px;
    column-gap: 0px;
  }

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    padding: 16px;
    column-gap: 0px;
  }
`

const PlusIcon = styled.img`
  margin: 40px 0px;
  width: 30px;
  height: 30px;

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    margin: 30px 10px;
    width: 40px;
    height: 40px;
  }

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].md}) {
    && {
      margin: 40px 0px;
      width: 30px;
      height: 30px;
    }
  }
`

const ItemDiv = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 112px;

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    width: 130px;
  }

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].lg}) {
    &&& {
      width: 112px;
    }
  }
`

const ItemName = styled.div`
  white-space: initial;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  p:nth-child(3) {
    color: ${props => props.theme.color.palette['red-60']};
    margin-bottom: 0px;
  }
`

const ContentFooter = styled.div`
  background-color: ${props => props.theme.color.palette['grey-10']};
  display: flex;
  flex-direction: column;
  border-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  padding: 20px;
  justify-content: center;
  align-items: center;
  column-gap: calc(100% * 20 / 447);
  button {
    width: 340px;
  }

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    display: flex;
    flex-direction: column;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 0px;
    justify-content: flex-end;
    align-items: center;
    padding: 15px;
    button {
      max-width: 218px;
      margin-top: 16px;
    }
  }

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].md}) {
    button {
      max-width: 257px;
    }
  }

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].lg}) {
    flex-direction: row;
    column-gap: calc(100% * 20 / 447);
    button {
      width: auto;
    }
  }
`

const FooterPricing = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
`

const OfferPrice = styled.div`
  color: ${props => props.theme.color.palette['red-60']};
  display: flex;
  justify-content: space-between;
`

const SpecialOfferText = styled.p`
  && {
    color: ${props => props.theme.color.palette['red-60']};
    line-height: 1.2rem;
  }
`

const TotalPrice = styled.div`
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    span:first-child {
      margin-right: 15px;
      padding-right: 58px;
    }
    span: nth-child(2) {
      position: absolute;
      right: 0px;
    }
  }
`

export {
  Title,
  Container,
  EssentialExtrasContainer,
  ItemsWrapper,
  ItemDiv,
  ItemName,
  PlusIcon,
  ContentFooter,
  FooterPricing,
  OfferPrice,
  TotalPrice,
  SpecialOfferText
}
